<template>
    <label class="scope-radio-label">
        <input
            name="radio"
            type="radio"
            :value="value"
            class="scope-radio-input"
            v-model="model"
        />
        <span :class="['scope-radio', { '-checked': checked }]"></span>
        <span class="scope-text">{{ label }}</span>
    </label>
</template>
<script setup>
import { ref, computed, defineModel, defineProps, onMounted } from 'vue';
const model = defineModel();

const props = defineProps({
    value: String | Object | Boolean | Number,
    label: String
});

const checked = computed(() => model.value === props.value);
</script>
<style lang="scss" scoped>
@import '../assets/styles/_main.scss';

.scope-radio-label {
    position: relative;
    display: flex;
    align-items: center;
    gap: 8px;

    .scope-radio-input {
        margin: 0;
        position: absolute;
        appearance: none;
        width: 16px;
        height: 16px;

        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;

        &:checked {
            content: '';
            display: block;
            width: 8px;
            height: 8px;
            background-color: $icons-light;
            border-radius: 50%;
            left: 4px;
        }
    }

    .scope-radio {
        width: 16px;
        height: 16px;
        border-radius: 50%;
        border: 1px solid $border;
        box-sizing: border-box;
        cursor: pointer;

        &.-checked {
            background-color: $primary-accent;
            border: none;
        }
    }

    .scope-text {
        cursor: pointer;
        color: $text-high-emphasis;
        @include fz-14;
        font-weight: 500;
    }
}
</style>
